import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LandingHero from './components/LandingHero';
import LandingFeatures from './components/LandingFeatures';
import LandingUseCases from './components/LandingUseCases';
import LandingHowItWorks from './components/LandingHowItWorks';
import LandingTestimonials from './components/LandingTestimonials';
import LandingFAQ from './components/LandingFAQ';

export default function AIAdGeneratorPage() {
  return (
    <>
      {/* SEO Meta */}
      <title>Best AI Ad Generator for Small Businesses | AdForge — Create Ads in Seconds</title>
      <meta
        name="description"
        content="AdForge is the best AI ad generator for small businesses, contractors, and beginners. Create high-converting Facebook, Instagram & Google ads with AI in under 3 minutes. No experience needed. Free to start."
      />
      <meta
        name="keywords"
        content="AI ad generator, best AI ad generator, how to create ads with AI, AI advertising tool, ad copy generator, AI marketing tool"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ad-generator" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Best AI Ad Generator for Small Businesses | AdForge" />
      <meta
        property="og:description"
        content="Create high-converting Facebook, Instagram, and Google ads with AI in under 3 minutes. No marketing experience needed. Try AdForge free."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ad-generator" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Best AI Ad Generator | AdForge" />
      <meta
        name="twitter:description"
        content="Generate professional ad copy and visuals with AI. Built for small businesses, contractors, and beginners. Free to start."
      />

      {/* Schema.org WebPage structured data */}
      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Best AI Ad Generator for Small Businesses — AdForge',
        description:
          'AdForge is the best AI ad generator for small businesses, contractors, and local brands. Create high-converting ads in seconds. No experience needed.',
        url: 'https://adforge.ai/ai-ad-generator',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '847',
          },
        },
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          {/* H1 lives inside LandingHero */}
          <LandingHero />
          <LandingFeatures />
          <LandingUseCases />
          <LandingHowItWorks />
          <LandingTestimonials />
          <LandingFAQ />

          {/* Final CTA banner */}
          <section className="py-20 lg:py-24 relative overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20glowing%20orange%20amber%20light%20waves%20and%20particles%20on%20dark%20charcoal%20background%2C%20dynamic%20energy%20flow%2C%20modern%20tech%20aesthetic%2C%20rich%20warm%20tones%2C%20ultra%20wide%20format%2C%20no%20text%2C%20elegant%20minimal%20design&width=1920&height=600&seq=cta-bg-final-01&orientation=landscape"
                alt=""
                className="w-full h-full object-cover object-top"
                aria-hidden="true"
              />
              <div className="absolute inset-0 bg-black/55" />
            </div>
            <div className="relative z-10 max-w-3xl mx-auto px-6 lg:px-8 text-center">
              <h2 className="text-3xl lg:text-4xl font-black text-white mb-4 leading-tight">
                Stop Struggling with Ad Copy. Let AI Do It.
              </h2>
              <p className="text-base text-stone-300 mb-8 leading-relaxed">
                Join <strong className="text-white">10,000+ business owners</strong> who use AdForge to
                create better ads, faster — without agencies, copywriters, or marketing degrees.
                The best AI ad generator is waiting for you.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link
                  to="/signup"
                  className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Generate Your First Ad Free
                </Link>
                <Link
                  to="/pricing"
                  className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  View Pricing
                </Link>
              </div>
              <p className="text-xs text-stone-400 mt-4">
                No credit card required &middot; 10 free ads on signup &middot; Cancel anytime
              </p>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}
